<sk-job-history
  titleText="Order Job History"
  [jobs]="backupOrderJobs"
  [isRefreshing]="isRefreshing"
  [days]="[]"
  (refreshEvent)="loadBackupOrderJobs($event)">
</sk-job-history>
